<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23.0002C18.299 23.0002 23 18.2992 23 12.5002C23 6.70119 18.299 2.00018 12.5 2.00018C6.70101 2.00018 2 6.70119 2 12.5002C2 18.2992 6.70101 23.0002 12.5 23.0002ZM13.1028 17.503L18.7884 13.2072L17.5827 11.6115L13.4999 14.6963L13.5 7.67137L11.5 7.67137L11.4999 14.6963L7.41712 11.6115L6.21146 13.2072L11.8971 17.503L12.4999 17.9585L13.1028 17.503Z"
      fill="#999999"
    />
  </svg>
</template>
